import { render, staticRenderFns } from "./contact-select.vue?vue&type=template&id=2d23cc91&scoped=true&"
import script from "./contact-select.vue?vue&type=script&lang=js&"
export * from "./contact-select.vue?vue&type=script&lang=js&"
import style0 from "./contact-select.vue?vue&type=style&index=0&id=2d23cc91&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23cc91",
  null
  
)

export default component.exports